import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Spin } from "antd";
import moment from "moment";

import styled from "styled-components";

import salesManageApi from "../../../../apis/SalesManage.api";

const SearchQuickMenu = ({
  searchOptions,
  setSearchOptions,
  setDateType,
  getUserOrderList,
}) => {
  const history = useHistory();
  const isLoading = useSelector((state) => state.common.loading);
  const user = useSelector((state) => state.auth.user);
  const [clickStatus, setClickStatus] = useState("");

  const [orderDeliveryStatus, setOrderDeliveryStatus] = useState({});

  // useEffect(() => {
  //     if (user?.id) {
  //         getOrderDeliveryStatus()
  //     }
  // }, [user]);

  useEffect(() => {
    if (clickStatus?.length) {
      if (searchOptions?.searchStatus === clickStatus) {
        getUserOrderList();
      }
    }
    if (!isLoading) {
      getOrderDeliveryStatus();
    }
    // console.log(searchOptions?.searchStatus, clickStatus);
  }, [clickStatus, searchOptions]);

  const getOrderDeliveryStatus = async () => {
    const param = {
      userId: user?.id === 724 ? 1 : user?.id,
    };
    const res = await salesManageApi.salesManageStatus(param);
    if (res.code === 200) {
      setOrderDeliveryStatus({
        ...orderDeliveryStatus,
        depositOrder: res.result.depositOrderCnt,
        newOrder: res.result.paidOrderList,
        // deliveryReady: res.result.deliveryReadyCnt,
        // deliveryShipping: res.result.deliveryShippingCnt,
        // deliveryComplete: res.result.deliveryCompleteCnt,
        deliveryReady: res.result.deliveryReadyList,
        deliveryShipping: res.result.deliveryShippingList,
        deliveryComplete: res.result.deliveryCompleteList,
        delivery12: res.result.deliveryReadyListPassed12,
        delivery24: res.result.deliveryReadyListPassed24,
        cancelRequest: res.result.cancelRequestList,
        returnRequest: res.result.returnRequestList?.length ?? 0,
        // returnComplete: res.result.returnCompleteList?.length ?? 0,
        exchangeRequest: res.result.exchangeRequestList?.length ?? 0,
      });
    }
  };

  /**
   * 배송 상태값 수
   * @param e
   */
  const handleDeliveryStatus = (e) => {
    const value = e.currentTarget.id;
    if (!isLoading) {
      if (value !== "delivery12" && value !== "delivery24") {
        setSearchOptions({
          ...searchOptions,
          searchStatus: value,
          startDate: moment().subtract(14, "days"),
          endDate: moment(),
          searchType: "payment_created_at",
        });
        setDateType("");
        setClickStatus(value);
      } else {
        if (value === "delivery12") {
          if (orderDeliveryStatus?.delivery12?.length) {
            let delivery =
              orderDeliveryStatus.delivery12[
                orderDeliveryStatus?.delivery12?.length - 1
              ]?.payment_created_at;
            // let endDate = moment().subtract(12, "hours");
            setSearchOptions({
              ...searchOptions,
              searchType: "payment_created_at",
              searchStatus: "delivery_ready",
              startDate: moment(delivery),
              endDate: moment().subtract(12, "hours"),
            });
            setDateType("");
          }
        } else if (value === "delivery24") {
          if (orderDeliveryStatus?.delivery24?.length) {
            let delivery =
              orderDeliveryStatus.delivery24[
                orderDeliveryStatus?.delivery24?.length - 1
              ]?.payment_created_at;

            // let endDate = moment().subtract(12, "hours");
            setSearchOptions({
              ...searchOptions,
              searchType: "payment_created_at",
              searchStatus: "delivery_ready",
              startDate: moment(delivery),
              endDate: moment().subtract(24, "hours"),
            });
            setDateType("");
          }
        }
        setClickStatus("delivery_ready");
      }
    }
  };

  return (
    <QuickList>
      <QuickEach>
        <QuickTitle>확인 후 먼저 처리해주세요!</QuickTitle>
        <QuickButtonListEach>
          <QuickButton
            className={!isLoading ? `quick-button` : ""}
            id={`delivery12`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
            style={isLoading ? {} : { cursor: "pointer" }}
          >
            {isLoading && <Spin className={`quick-spin`} />}
            <QuickButtonTitle>12시간 이후 (배송준비중)</QuickButtonTitle>
            <QuickButtonTitle style={{ color: "#ff8000" }}>
              <b>{orderDeliveryStatus?.delivery12?.length ?? 0}</b>
            </QuickButtonTitle>
          </QuickButton>
          <QuickButton
            className={!isLoading ? `quick-button` : ""}
            id={`delivery24`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`quick-spin`} />}
            <QuickButtonTitle>24시간 이후 (배송준비중)</QuickButtonTitle>
            <QuickButtonTitle style={{ color: "#fe2b4b" }}>
              <b>{orderDeliveryStatus?.delivery24?.length ?? 0}</b>
            </QuickButtonTitle>
          </QuickButton>
          <QuickButton
            className={!isLoading ? `quick-button` : ""}
            id={`cancel_request`}
            onClick={() => {
              history.push(`/salesManage/cancel`);
            }}
            disabled={isLoading}
            style={isLoading ? {} : { cursor: "pointer" }}
          >
            {isLoading && <Spin className={`quick-spin`} />}
            <QuickButtonTitle>취소 요청</QuickButtonTitle>
            <QuickButtonTitle>
              <b>{orderDeliveryStatus?.cancelRequest?.length ?? 0}</b>
            </QuickButtonTitle>
          </QuickButton>
        </QuickButtonListEach>
      </QuickEach>

      <QuickEach>
        <QuickTitle>배송 현황</QuickTitle>
        <QuickButtonListEach>
          <QuickButton
            className={!isLoading ? `quick-button` : ""}
            id={`paid`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`quick-spin`} />}
            <QuickButtonTitle>결제완료 (발주확인 필요)</QuickButtonTitle>
            <QuickButtonTitle>
              <b>{orderDeliveryStatus?.newOrder?.length ?? 0}</b>
            </QuickButtonTitle>
          </QuickButton>

          <QuickButton
            className={!isLoading ? `quick-button` : ""}
            id={`delivery_ready`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`quick-spin`} />}
            <QuickButtonTitle>배송준비중 (발송처리 필요)</QuickButtonTitle>
            <QuickButtonTitle>
              <b>{orderDeliveryStatus?.deliveryReady?.length ?? 0}</b>
            </QuickButtonTitle>
          </QuickButton>

          <QuickButton
            className={!isLoading ? `quick-button` : ""}
            id={`delivery_shipping`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`quick-spin`} />}
            <QuickButtonTitle>배송중</QuickButtonTitle>
            <QuickButtonTitle>
              <b>{orderDeliveryStatus?.deliveryShipping?.length ?? 0}</b>
            </QuickButtonTitle>
          </QuickButton>

          <QuickButton
            className={!isLoading ? `quick-button` : ""}
            id={`delivery_complete`}
            onClick={handleDeliveryStatus}
            disabled={isLoading}
          >
            {isLoading && <Spin className={`quick-spin`} />}
            <QuickButtonTitle>배송완료</QuickButtonTitle>
            <QuickButtonTitle>
              <b>{orderDeliveryStatus?.deliveryComplete?.length ?? 0}</b>
            </QuickButtonTitle>
          </QuickButton>
        </QuickButtonListEach>
      </QuickEach>
    </QuickList>
  );
};

const QuickList = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1em;
`;

const QuickEach = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

const QuickButtonListEach = styled.div`
  display: flex;
  gap: 1%;
  width: 100%;
`;

const QuickTitle = styled.p`
  margin: 0;
  color: #343a40;
  font-size: 1.1em;
`;

const QuickButton = styled.button`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  padding: 0.7em 1.3em;
  width: 24.25%;
  background: white;
  border: solid 1px #ced4da;
  border-radius: 5px;
`;

const QuickButtonTitle = styled.p`
  font-size: 1em;
  color: #343a40;
  margin: 0;
`;
export default SearchQuickMenu;
